import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, FormControlLabel, Checkbox,
  Select, MenuItem, InputLabel, FormControl, Typography, Divider
} from '@material-ui/core';
import { AuctionListLimit } from "../../../adminModel/auctions";
import Autocomplete from '@material-ui/lab/Autocomplete';

const AddReleasingDialog = ({ open, onClose, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    event: '',
    lot_number: '',
    client_name: '',
    auction_name: '',
     purpose: '',
     delivered_by: '',
     released_by: '',
  });
  
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };


  const handleSubmit = async () => {
 
    try {
      const payload = {
        auction_id: formData.event?.id || '',
        lot_number: (formData.lot_number || '')
        .replace(/\n/g, ',')
        .replace(/\s/g, ''),
        client_name: formData.client_name,
        auction_name: formData.auction_name,
        deliver: formData.delivered_by,
  
      };
      onSubmit(payload);
      // ... your submission logic
      if (typeof onClose === 'function') {
        onClose();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const handleSubmit = () => {
  //   const payload = {
  //     auction_id: formData.event?.id || '',
  //     lot_number: formData.lot_number.replace(/\n/g, ',').replace(/\s/g, ''),
  //     client_name: formData.client_name,
  //     auction_name: formData.auction_name,
  //     deliver: formData.delivered_by,

  //   };

  //   // console.log("Releasing submitted:", payload);
  //   onSubmit(payload);
  //   onClose();
  // };
  
  const [eventList, setEventList] = useState([]);
  useEffect(() => {
    async function fetchEvents() {
      const response = await AuctionListLimit();
      console.log('AuctionListLimit response:', response); // 👈 check this
      setEventList(response.data || []);
    }
  
    fetchEvents();
  }, []);


  // const [geteventList, setEventList] = useState([]);
  // useEffect(() => {
  //   setLoading(true);
  //   async function fetchData() {
   
  //     const results = await AuctionListLimit();
  //     setLoading(false);
  //     setEventList(results.data);
  //   }
  //   fetchData().catch((error) => {
  //     // console.log(' error.response.data.message: ', error.response.data.message)
  //     setLoading(false);
  //   });
  // }, []);

  return (
    
    <Grid container spacing={4}>
    {/* Left Section */}
    <Grid item xs={12} md={6}>
      <Typography variant="subtitle1" gutterBottom>
        Enter Lot Numbers
      </Typography>
      <TextField
        placeholder={'e.g '+`\n1\n2\n3`}
        multiline
        rows={10}
        fullWidth
        variant="outlined"
        value={formData.lot_number}
        onChange={handleChange('lot_number')}
      />
    </Grid>
  
    {/* Right Section */}
    <Grid item xs={12} md={6}>
      <Typography variant="subtitle1" gutterBottom>
        Details
      </Typography>
  
      <Autocomplete
        options={eventList}
        getOptionLabel={(option) => option.auction_name || ''}
        getOptionSelected={(option, value) => option.id === value.id}
        value={formData.event || null}
        onChange={(e, newValue) => {
          if (newValue) {
            setFormData({
              ...formData,
              event: newValue,
              auction_name: newValue.auction_name,
              auction_id: newValue.id,
            });
          } else {
            setFormData({
              ...formData,
              event: '',
              auction_name: '',
              auction_id: '',
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Event"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        )}
      />
  
      <TextField
        label="Name"
        fullWidth
        variant="outlined"
        margin="dense"
        value={formData.client_name}
        onChange={handleChange('client_name')}
      />
      {/* <TextField
        label="Purpose"
        fullWidth
        variant="outlined"
        margin="dense"
        value={formData.purpose}
        onChange={handleChange('purpose')}
      />
      <TextField
        label="Released By"
        fullWidth
        variant="outlined"
        margin="dense"
        value={formData.released_by}
        onChange={handleChange('released_by')}
      />*/}
      {/* <TextField
        label="Released To"
        fullWidth
        variant="outlined"
        margin="dense"
        value={formData.delivered_by}
        onChange={handleChange('delivered_by')}
      />  */}
    </Grid>
  
    {/* Buttons Row */}
    <Grid item xs={12}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <Button onClick={onClose} color="default" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Submit
        </Button>
      </div>
    </Grid>
  </Grid>
  
   
  );
};

export default AddReleasingDialog;
